import { getRequest } from 'utils/http'

export const getActivityFeedApi = () => {
  return getRequest('/activity-feed')
}
